import { Button, Text, Box, Input } from "@chakra-ui/react"
import WithAuth from "../components/hoc/with-auth"
import { AuthLayout } from "../components/layouts/index"
import { LayoutWithSidebar } from "../components/layouts/layout-with-sidebar.tsx/index"
import DealsPage from "../components/pages/deals-page/index"
import OpenPositionsPage from "../components/pages/open-positions"
import TradesByIPPage from "../components/pages/trades-by-ip-page"
import CommissionReportPage from "../components/pages/commission-report-page"

const CommissionReport = () => {
  return (
    <>
      <WithAuth>
        <LayoutWithSidebar
          pageTitle="Commission Report"
          pageDesc="List of all commission report"
        >
          <CommissionReportPage />
        </LayoutWithSidebar>
      </WithAuth>
    </>
  )
}

export default CommissionReport
